<script lang="ts">
  import { createEventDispatcher } from 'svelte';
  // @ts-ignore
  import * as DropdownMenu from '$lib/components/ui/dropdown-menu';
  // @ts-ignore
  import { Button } from '$lib/components/ui/button';
  import Icon from '$shared/icons/Icon.svelte';

  export let addQuestionText = 'Add question';
  export let multipleChoiceText = 'Multiple choice';
  export let openEndedText = 'Open-ended';

  const dispatch = createEventDispatcher();
</script>

<DropdownMenu.Root>
  <DropdownMenu.Trigger asChild let:builder>
    <Button builders={[builder]} variant="outline" class="h-10 gap-2 bg-white font-medium">
      <Icon icon="Plus" size="small" />
      {addQuestionText}
    </Button>
  </DropdownMenu.Trigger>
  <DropdownMenu.Content align="start" sideOffset={8} class="flex flex-col gap-6 rounded-lg bg-white p-4">
    <DropdownMenu.Item
      class="cursor-pointer gap-3 rounded-md p-2 text-base font-medium text-black"
      on:click={() => dispatch('select', 'multiple_choice')}
    >
      <Icon icon="List" iconClass="w-5 h-5" />
      {multipleChoiceText}
    </DropdownMenu.Item>
    <DropdownMenu.Item
      class="cursor-pointer gap-3 rounded-md p-2 text-base font-medium text-black"
      on:click={() => dispatch('select', 'open_ended')}
    >
      <Icon icon="MessageSquare" iconClass="w-5 h-5" />
      {openEndedText}
    </DropdownMenu.Item>
  </DropdownMenu.Content>
</DropdownMenu.Root>
